import { render, staticRenderFns } from "./merchant-class-add.vue?vue&type=template&id=94b50222&scoped=true"
import script from "./merchant-class-add.vue?vue&type=script&lang=js"
export * from "./merchant-class-add.vue?vue&type=script&lang=js"
import style0 from "./merchant-class-add.vue?vue&type=style&index=0&id=94b50222&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b50222",
  null
  
)

export default component.exports